module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/seller/sub-component/kitchen/kitchen-scope/kitchen-scope.component.scss
// module id = ./src/app/seller/sub-component/kitchen/kitchen-scope/kitchen-scope.component.scss
// module chunks = main